<template>
  <news-details-wrapper :article-type="StrapiArticleType.News" />
</template>

<script lang="ts" setup>
import { StrapiArticleType } from '#variant/apollo/types/types';

defineOptions({
  name: 'NewsArticlePage',
});

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    de: '/news/[slug]',
    en: '/news/[slug]',
    pt: '/news/[slug]',
    fr: '/news/[slug]',
    nl: '/news/[slug]',
    it: '/news/[slug]',
    ja: '/news/[slug]',
    pl: '/news/[slug]',
    // ru: '/news/[slug]',
    es: '/news/[slug]',
    zh: '/news/[slug]',
  },
});
</script>
